var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKmxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#053361;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.8,557V324.2H145v102.6h3.1l83.8-102.6h59l-86.4,104.2L291.8,557H233l-63.8-95.7L145,490.8V557H95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,324.2h60.7l64.1,156.4h2.7l64.1-156.4h60.7V557h-47.7V405.5h-1.9l-60.2,150.3h-32.5l-60.2-150.9h-1.9 v152H305V324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M632.3,324.2l46.9,79.3h1.8l47.2-79.3h55.6l-71,116.4L785.4,557h-56.6l-47.7-79.4h-1.8L631.5,557h-56.4 L648,440.6l-71.5-116.4H632.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmxIcon);
export default __webpack_public_path__ + "static/media/kmx_icon.639b2c50a55f39f9dbe3a584cd1da3e9.svg";
export { ForwardRef as ReactComponent };